import React, { useState } from "react";

import { toggleFullscreen } from "../../utils/actions";

import fullscreen from "../../assets/images/icons/whiteboard-menu-left-5.svg";
import fullscreenExit from "../../assets/images/icons/whiteboard-menu-left-6.svg";

const FullScreen = (props: any) => {
  const { screenMode, setScreenMode, user, toolScale } = props;
  return (
    <React.Fragment>
      <button
        style={{
          transform: `scale(${ toolScale })`,
          left: `calc(46px * ${ toolScale })`,
          bottom: `calc(70px * ${ toolScale })`,
        }}
        className={`feature-anchor top-tool-btn fullScreen-btn ${user? "guest-btn" : ""}`}
        onClick={() => toggleFullscreen(setScreenMode)} data-tooltip-content={`${ screenMode? "全螢幕" : "關閉全螢幕" }`}
      >
        {screenMode? (
          <img src={fullscreen} alt="" />
        ) : (
          <img src={fullscreenExit} alt="" />
        )}
      </button>
    </React.Fragment>
  );
};

export default FullScreen;